<template>
    <div>
        <div class="container-my-none q-my-lg">
            <img v-if="productLine" :src="productLine.logo" class="img-activation q-my-sm" :title="productLine.name" />
        </div>
        <license-subscription-info :productLine="productLine" />
        <q-page-sticky position="bottom-right" :offset="[18, 18]">
            <q-btn fab icon="mdi-arrow-left" color="primary" @click="$router.push(`/activation/${productLineName}`)" />
        </q-page-sticky>
    </div>
</template>

<script>
    import { productLines } from '@/plugins/productLines'
    import licenseSubscriptionInfo from '@/components/LicenseSubscriptionInfo'
    export default {
        name: 'license-subscription-info-view',
        components: {
            licenseSubscriptionInfo,
        },
        props: {
            productLineName: String,
        },
        data() {
            return {
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                })?.filter(pl => pl?.name.toLowerCase() !== 'lengthwise'),
                productLine: null,
            }
        },
        methods: {
        },
        computed: {
        },
        mounted() {
            if (this.productLineName) {
                this.productLine = this.productLines?.find(x => x.name.toLowerCase() == this.productLineName.toLowerCase())
                if (!this.productLine) this.productLine = this.productLines.LoopCAD
            }
            else this.productLine = productLines.LoopCAD
        },
        watch: {
            productLineName(newVal) {
                this.productLine = this.productLines?.find(x => x.name.toLowerCase() == newVal.toLowerCase())
                if (!this.productLine) this.productLine = productLines.LoopCAD
            }

        }
    }
</script>
